import type {FeedbackReaction} from '@Components/feedback-toast/feedback-toast.types';
import {MDE_FEEDBACK_URL_PARAM} from '@Libraries/make-design-editable.library.types';
import {serializeUrl} from '@Utils/url.util';

const clearMdeFeedbackUrlParam = (): void => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(MDE_FEEDBACK_URL_PARAM)) {
    return;
  }
  url.searchParams.delete(MDE_FEEDBACK_URL_PARAM);
  window.history.replaceState(null, '', serializeUrl(url));
};

/** Never throws, so the toast state machine cannot stick. */
const postFeedback = async (endpoint: string, params: Record<string, string>): Promise<boolean> => {
  try {
    await window.PMW.writeLocal(endpoint, params);
    return true;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
};

/** The comment is only sent once the reaction was saved: the server refuses a comment without a reaction row. */
export const showMdeFeedbackToast = (jobId: string): void => {
  clearMdeFeedbackUrlParam();
  let isReactionRecorded = false;
  window.PMW.showFeedbackToast({
    onFeedbackReaction: async (reaction: FeedbackReaction): Promise<void> => {
      isReactionRecorded = await postFeedback('makedesigneditable/recordFeedbackReaction', {jobId, reaction});
    },
    onFeedbackTextInput: async (comment: string): Promise<void> => {
      if (!isReactionRecorded) {
        return;
      }
      await postFeedback('makedesigneditable/recordFeedbackComment', {jobId, comment});
    },
    reactionPageHeaderTitle: window.i18next.t('pmwjs_mde_feedback_reaction_title'),
    reactionPageHeaderIcon: 'icon-sparkle',
    feedbackInputHeaderTitle: window.i18next.t('pmwjs_help_us_improve'),
    feedbackInputHeaderIcon: 'icon-message',
    feedbackInputPlaceholder: window.i18next.t('pmwjs_explain_your_experience_ellipsis'),
    postSubmissionText: window.i18next.t('pmwjs_thanks_this_will_help_us_improve'),
  });
};
